import { useQuery } from '@tanstack/react-query';
import { getAssetPrices } from '../requests';
import { CACHE_TIME_5_MINUTES } from '@/shared/config';

interface UseAssetPricesOptions {
  asset: string;
  enabled?: boolean;
  staleTime?: number;
  gcTime?: number;
}

export function useAssetPrices({
  asset,
  enabled = true,
  staleTime = 1000 * 60,
  gcTime = CACHE_TIME_5_MINUTES,
}: UseAssetPricesOptions) {
  const query = useQuery({
    queryKey: ['asset-prices', asset],
    queryFn: async () => {
      return await getAssetPrices(asset);
    },
    enabled: enabled && !!asset,
    staleTime,
    gcTime,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
